import { Component, Inject, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { FormValidator } from 'src/app/helper/validator/form.validator';
import { IGroup } from 'src/models/user/group.interface';

@Component({
    selector: 'app-add-edit-phone-device',
    templateUrl: './add-edit-phone-device.component.html',
    styleUrls: ['./add-edit-phone-device.component.css'],
    standalone: false
})
export class AddEditPhoneDeviceComponent {
  deviceForm: FormGroup;

  constructor( @Inject(MAT_DIALOG_DATA) public data: {number: string, typeId: number, preferred: boolean, visible: boolean, deviceTypes: IGroup[]}, 
                private dialogRef: MatDialogRef<AddEditPhoneDeviceComponent>, private formValidator: FormValidator, private snackBar: MatSnackBar) {
      if(data){
        this.deviceForm = new FormGroup({
          number : new FormControl(data.number, Validators.required),
          typeId: new FormControl(data.typeId, Validators.required),
          preferred: new FormControl(data.preferred),
          visible: new FormControl(data.visible)
        });
      }
      else{
        this.deviceForm = new FormGroup({
          number : new FormControl('', Validators.required),
          typeId: new FormControl('', Validators.required),
          preferred: new FormControl(false),
          visible: new FormControl(false)
        });
      }
  }

  onCancelEditingDevice(): void{
    this.dialogRef.close();
  }

  onSavingDevice(): void{
    if(this.deviceForm.valid){
      this.dialogRef.close(this.deviceForm);
      return;
    }
    this.deviceForm.markAllAsTouched();
  }

  onDeviceNumberInput(event: KeyboardEvent){
    if(!this.formValidator.isNumChar(event)){
      event.preventDefault();
      this.snackBar.open('Please enter numeric values only', 'ok', {
        duration: 5000
      });
      return;
    }
  }
}
